import type {FC, ReactNode} from 'react'

import styles from './LinkedSecurityAlerts.module.css'

export const LinkedSecurityAlertsPill: FC<{children: ReactNode}> = props => (
  <div className={styles.linkedSecurityAlertsPill} {...props} />
)
